import React from "react";
import { useStyles } from "./style";
import { CopyRightProps } from "./types";
import useWindowSize from "../../hooks/change-size";

export const CopyRight = (props: CopyRightProps) => {
    const classes = useStyles();
    const deviceWidth = useWindowSize().width <= 1200;
    const year = new Date().getFullYear();

    return (
        <section className={classes.copyRightContainer + ' copyRightContainerHelper'}>
            <div className={classes.copyRight}>
              <a href={props.copyRight.href} target="_blank">© {`${year} ` + props.copyRight.text}</a>
            </div>
            <div className={[classes.copyRightLinks, ...(props.classes || [])].join(' ')}>
                <a className={"underline " + classes.copyRightLink} href={props.privacy.href.toLowerCase()} target="_blank">
                    {props.privacy.text}
                </a>
                {deviceWidth && props.terms?.text && <span className={classes.copyRightSeparator} /> }
                {props.terms?.text && <a className={"underline " + classes.copyRightLink} href={props.terms?.href.toLowerCase()} target="_blank">
                  {props.terms?.text}
                </a>}
                {deviceWidth && props.consent?.text && props.classes?.includes('copy-right-ru') && <span className={classes.copyRightSeparator} /> }
                {props.consent?.text && <a className={"underline " + classes.copyRightLink} href={props.consent?.href.toLowerCase()} target="_blank">
                  {props.consent?.text}
                </a>}
                {deviceWidth && props.userAgreement?.text && <span className={classes.copyRightSeparator} /> }
                {props.userAgreement?.text && <a className={"underline " + classes.copyRightLink} href={props.userAgreement?.href.toLowerCase()} target="_blank">
                  {props.userAgreement?.text}
                </a>}
            </div>
        </section>
    );
};
